import React, { useState, useEffect } from "react";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import { useBetween } from "use-between";
import useShopify from "../../../useShopify";
import Logo from "../../../assets/images/boxfox.png";
import RegentLogo from "../../../assets/images/regent-logo.png";
import RegentLogo2 from "../../../assets/images/regent-logo2.png";
import "./index.scss";

const EmailInput = ({
  errorMessage,
  setErrorMessage,
  next,
  isOutlier,
  updateFormBasedOnBooking,
}) => {
  const [booking, setBooking] = useState("");
  const [pending, setPending] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [infoMsg, setInfoMsg] = useState("");

  const { campaign, getOrder } = useBetween(useShopify);

  const isRegent =
    campaign.companyId === process.env.REACT_APP_REGENT_COMPANY_ID;

  useEffect(() => {
    if (isOutlier) {
      setInfoMsg(
        "Your situation is unique! Please email concierge@shopBOXFOX.com to finalize your sizes!"
      );
    }
  }, [isOutlier]);

  useEffect(() => {
    setErrorMsg("");
    setInfoMsg("");
  }, []);

  useEffect(() => {
    setErrorMsg(errorMessage);
    if (errorMessage != "") {
      setInfoMsg(
        "For questions please email our partners at BOXFOX | concierge@shopboxfox.com"
      );
    }
  }, [errorMessage]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setPending(true);
    setErrorMessage("");

    const order = await getOrder(booking);
    if (order) {
      setErrorMsg("Your order has already been created.");
      setInfoMsg(
        "For questions please email our partners at BOXFOX | concierge@shopboxfox.com"
      );
    } else {
      updateFormBasedOnBooking(booking, 2);
      setPending(false);
      // check if booking number is in csv
      // if (userRow) {

      // } else {
      //   setPending(false);
      //   setErrorMsg("We couldn't find this booking number in our system.");
      // }
    }
  };

  const normalizedCampaignNameForDisplay = (campaign?.name || '').toLowerCase().replace(/[-\s]/g, '');
  const isGrandAsiaCampaign = normalizedCampaignNameForDisplay.includes('grandasia') || normalizedCampaignNameForDisplay.includes('grandasianexploration') || normalizedCampaignNameForDisplay.includes('indianodyssey');
  // World Cruise 2027 drops the split banner layout for a full-width centered one.
  const isWorldCruise2027 = normalizedCampaignNameForDisplay.includes('worldcruise2027');


  return (
    <>
      {Object.keys(campaign).length ? (
        <div
          className={`brand-dashboard default-font ${isWorldCruise2027 ? "brand-dashboard--centered" : ""}`}
          style={{
            ...(campaign.color ? { backgroundColor: campaign.color } : {}),
            // Without the banner the page background is what shows, so match the container.
            ...(isWorldCruise2027 && campaign.bgColor
              ? { backgroundColor: campaign.bgColor }
              : {}),
          }}
        >
          <div className="banner">
            {campaign.loginImage.path ? (
              <img
                style={isRegent ? { backgroundColor: 'white', objectFit: 'contain' } : null}
                src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
                alt="banner"
              />
            ) : null}
          </div>
          <Container
            style={
              campaign.bgColor ? { backgroundColor: campaign.bgColor } : null
            }
            className="brand-actions"
          >
            <div className="logo">
              {isRegent ? (
                <img
                style={isWorldCruise2027 ? null : { transform: "scale(0.35)" }}
                  src={
                    // World Cruise 2027 uses the logo uploaded on the campaign.
                    isWorldCruise2027 && campaign.logo.path
                      ? `${process.env.REACT_APP_API_URL}/${campaign.logo.path}`
                      : isGrandAsiaCampaign
                        ? RegentLogo2
                        : RegentLogo
                  }
                  alt="Regent Logo"
                />
              ) : (
                <img src={Logo} alt="logo" />
              )}
            </div>
            <div className="company-logo mb-0">
              {isRegent ? null : (
                campaign.logo.path ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                    alt="Company Logo"
                  />
                ) : null
              )}
            </div>
            <p
              style={{
                color: campaign.textColor || null,
              }}
              className="brand-desc pwd"
            >
              {campaign.customBodyText.split("<br>").map((text, index) => (
                <React.Fragment key={index}>
                  {text}
                  {index < campaign.customBodyText.split("<br>").length - 1 && (
                    <br />
                  )}
                </React.Fragment>
              ))}
            </p>
            <Form
              className="w-100"
              onSubmit={(event) => {
                handleSubmit(event);
              }}
            >
              <Form.Group className="company-login">
                <Form.Control
                  type="text"
                  value={booking}
                  onChange={(event) => {
                    setErrorMsg("");
                    setInfoMsg("");
                    setPending(false);
                    setBooking(event.target.value);
                  }}
                  placeholder="Booking Code"
                  required
                />
                <p className="error">{errorMsg}</p>
                <p className="info">{infoMsg}</p>
              </Form.Group>
              {campaign.loginText ? (
                <p
                  style={{
                    color: campaign.textColor || null,
                  }}
                >
                  {campaign.loginText}
                </p>
              ) : null}
              <Button
                className="mb-4"
                style={{
                  backgroundColor: campaign.buttonColor || null,
                  color: campaign.buttonTextColor || null,
                  border:
                    (campaign.buttonStrokeColor &&
                      `2px solid ${campaign.buttonStrokeColor}`) ||
                    null,
                }}
                type="submit"
              >
                {!pending ? "Next" : <Spinner animation="border" />}
              </Button>
            </Form>
          </Container>
        </div>
      ) : null}
    </>
  );
};

export default EmailInput;
